import Axios from 'axios';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import CheckoutSteps from '../component/CheckoutSteps';
import { Helmet } from 'react-helmet-async';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Store } from '../Store';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { getError, productPath } from '../utils';
import LoadingBox from '../component/LoadingBox';
import Header from '../ecommerce/Header';
import Footer from '../ecommerce/Footer';
import { api } from "../Api";
import SecurityBadges from '../component/SecurityBadges';


const reducer = (state, action) => {
  switch (action.type) {
    case 'CREATE_REQUEST':
      return { ...state, loading: true };
    case 'CREATE_SUCCESS':
      return { ...state, loading: false };
    case 'CREATE_FAIL':
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default function PlaceOrderScreen() {
  const navigate = useNavigate();
  const [{ loading }, dispatch] = useReducer(reducer, {
    loading: false,
  });

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { cart, userInfo } = state;

  // The delivery rule the developer set, served with the wallet below. Off
  // (free) until it loads — the server prices the order either way.
  const [delivery, setDelivery] = useState({ enabled: false, mode: 'per_item', amount: 0 });
  const vat = 0;

  var total_items = cart.cartItems.reduce((a, c) => a + c.quantity, 0);
  const pickup = cart.shippingAddress.delivery_method === 'pick_from_store';
  var total_product = cart.cartItems.reduce(
    (a, c) => a + c.price * c.quantity,
    0
  );
  var total_delivery_charge =
    !delivery.enabled || pickup
      ? 0
      : Math.round(delivery.mode === 'per_order' ? delivery.amount : delivery.amount * total_items);
  var total_tax =
    Math.round((total_delivery_charge + total_product) * vat) / 100;
  var grand_total = total_product + total_delivery_charge + total_tax;
  var totalPoint = cart.cartItems.reduce((a, c) => a + c.point * c.quantity, 0);
  useEffect(() => {
    if (!cart.shippingAddress) {
      navigate('/shipping');
    }
  }, [cart, navigate]);

  // Shopping-balance checkout. When the admin turns it on, the order is paid
  // from Shopping Balance the moment it is placed, so the member sees what it
  // costs and what is left before confirming.
  const [wallet, setWallet] = useState({ loaded: false, required: false, balance: 0 });
  const loadWallet = async () => {
    if (!userInfo) return;
    try {
      const { data } = await Axios.get(api + `/api/users/point/${userInfo._id}`, {
        headers: { authorization: `Bearer ${userInfo.token}` },
      });
      if (data.delivery) setDelivery(data.delivery);
      setWallet({
        loaded: true,
        required: Boolean(data.moneyPolicy?.shoppingCheckoutRequired),
        balance: Number(data.shoppingbalance) || 0,
      });
    } catch (err) {
      setWallet((w) => ({ ...w, loaded: true }));
    }
  };
  useEffect(() => {
    loadWallet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  const money = (v) =>
    (Number(v) || 0).toLocaleString('en-US', { maximumFractionDigits: 2 });
  const remaining = Math.round((wallet.balance - grand_total) * 100) / 100;
  const insufficient = wallet.required && remaining < 0;

  const placeOrderHandler = async () => {
    try {
      dispatch({ type: 'CREATE_REQUEST' });

      const { data } = await Axios.post(
        api + '/api/orders/createneworder',
        {
          orderItems: cart.cartItems,
          shippingAddress: cart.shippingAddress,
          itemsPrice: total_product,
          shippingPrice: total_delivery_charge,
          taxPrice: total_tax,
          totalPrice: grand_total,
          totalPoint: totalPoint,
        },
        {
          headers: { authorization: `Bearer ${userInfo.token}` },
        }
      );
      ctxDispatch({ type: 'CART_CLEAR' });
      dispatch({ type: 'CREATE_SUCCESS' });
      localStorage.removeItem('cartItems');
      if (wallet.required) toast.success(data.message);
      navigate(`/order/${data.order._id}`);
    } catch (err) {
      dispatch({ type: 'CREATE_FAIL' });
      if (err.response?.data?.code === 'INSUFFICIENT_SHOPPING_BALANCE') {
        loadWallet();
      }
      toast.error(getError(err));
    }
  };

  return (
    <div>
      <Helmet>
        <title>Place Order | Icon Marketing.</title>
      </Helmet>
      <Header />
      <div
        className="po-page"
        style={{ maxWidth: 1200, margin: 'auto', padding: '1rem' }}
      >
        <Row>
          <Col xs={12} lg={8}>
            <div className="card mb-3">
              <div className="card-header bg-white ">
                Order Summary{' '}
                <b style={{ float: 'right' }}>
                  <Link to="/cart">Edit</Link>{' '}
                </b>{' '}
              </div>
              <div className="card-body  bg-white">
                <div className="table-responsive"><table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th className="text-center">Products</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart.cartItems.map((item) => (
                      <tr key={item.slug}>
                        <td>
                          <img
                            src={item.image}
                            alt={item.name}
                            className="img-fluid rounded"
                            style={{ width: '5rem', height: '3rem' }}
                          ></img>{' '}
                          <Link to={productPath(item)} className="d-inline-block text-truncate align-middle" style={{ maxWidth: '12rem' }}>
                            {item.name}
                          </Link>
                        </td>
                        <td>৳{item.price}</td>
                        <td>{item.quantity}</td>
                        <td>৳ {item.price * item.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table></div>
              </div>
            </div>

            <div className="card mb-3 bg-white">
              <div className="card-header bg-white">
                Delivery Address Overview{' '}
                <Link style={{ float: 'right' }} to="/shipping">
                  Edit
                </Link>{' '}
              </div>
              <div className="card-body">
                <div className="table-responsive"><table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <td>Delivery Method </td>
                      <td>:</td>
                      <td>
                        {cart.shippingAddress.delivery_method ===
                        'pick_from_store'
                          ? 'Pick from the Store'
                          : 'Home Delivery'}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      className={
                        cart.shippingAddress.delivery_method ===
                        'pick_from_store'
                          ? 'd-none'
                          : ''
                      }
                    >
                      <td>Receiver Name </td>
                      <td>:</td>
                      <td>{cart.shippingAddress.fullName}</td>
                    </tr>
                    <tr
                      className={
                        cart.shippingAddress.delivery_method ===
                        'pick_from_store'
                          ? 'd-none'
                          : ''
                      }
                    >
                      <td>Street Address </td>
                      <td>:</td>
                      <td>{cart.shippingAddress.streetAddress}</td>
                    </tr>
                    <tr
                      className={
                        cart.shippingAddress.delivery_method ===
                        'pick_from_store'
                          ? 'd-none'
                          : ''
                      }
                      paymentMethod
                    >
                      <td>City </td>
                      <td>:</td>
                      <td>{cart.shippingAddress.city}</td>
                    </tr>
                    <tr
                      className={
                        cart.shippingAddress.delivery_method ===
                        'pick_from_store'
                          ? 'd-none'
                          : ''
                      }
                      paymentMethod
                    >
                      <td>Phone </td>
                      <td>:</td>
                      <td>{cart.shippingAddress.phone}</td>
                    </tr>
                  </tbody>
                </table></div>
              </div>
            </div>
          </Col>

          <Col xs={12} lg={4}>
            <div className="card mb-3 bg-white">
              <div className="card-header bg-white">Order Confirmation </div>
              <div className="card-body">
                <div className="table-responsive"><table className="table align-middle mb-0">
                  <tr key="total_items">
                    <td>Total Quantity </td>
                    <td>:</td>
                    <td>{total_items} </td>
                  </tr>
                  <tr key="total_product">
                    <td>Total Products </td>
                    <td>:</td>
                    <td>৳{total_product}</td>
                  </tr>
                  <tr key="total_delivery_charge">
                    <td>Total Delivery Charge </td>
                    <td>:</td>
                    <td>{total_delivery_charge ? `৳${total_delivery_charge}` : 'Free'}</td>
                  </tr>

                  <tr key="total_tax">
                    <td>Total Tax </td>
                    <td>:</td>
                    <td>৳{total_tax}</td>
                  </tr>
                  <tr key="grand_total">
                    <td>Grand Total </td>
                    <td>:</td>
                    <td>৳{grand_total}</td>
                  </tr>
                </table></div>
              </div>
              {wallet.required && (
                <div className="card-body border-top">
                  <div
                    className="p-3 rounded-3 mb-2"
                    style={{
                      background: 'linear-gradient(135deg, #0b1526, #13294a 60%, #0d3b36)',
                      color: '#fff',
                    }}
                  >
                    <div className="small text-uppercase" style={{ opacity: 0.7, letterSpacing: '0.06em' }}>
                      <i className="fa fa-credit-card" aria-hidden="true"></i> Paying with Shopping Balance
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <span style={{ opacity: 0.8 }}>Your balance</span>
                      <b>৳{money(wallet.balance)}</b>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span style={{ opacity: 0.8 }}>This order</span>
                      <b>− ৳{money(grand_total)}</b>
                    </div>
                    <hr style={{ borderColor: 'rgba(255,255,255,0.25)', margin: '0.5rem 0' }} />
                    <div className="d-flex justify-content-between">
                      <span>Remaining after order</span>
                      <b style={{ color: insufficient ? '#ff9b9b' : '#f4e3bd' }}>
                        {insufficient ? '—' : `৳${money(remaining)}`}
                      </b>
                    </div>
                  </div>
                  {insufficient && (
                    <div className="alert alert-warning mb-0 py-2 small">
                      <b>Not enough Shopping Balance.</b> You need ৳{money(-remaining)} more
                      to place this order.{' '}
                      <Link to="/topup">Top up now</Link> or remove an item from your{' '}
                      <Link to="/cart">cart</Link>.
                    </div>
                  )}
                </div>
              )}
              <div className="card-footer text-muted">
                <div className="d-grid">
                  <Button
                    type="button"
                    variant="outline-success"
                    disabled={
                      cart.cartItems.length === 0 ||
                      loading ||
                      insufficient ||
                      !wallet.loaded
                    }
                    onClick={() => placeOrderHandler()}
                  >
                    {wallet.required
                      ? `Pay ৳${money(grand_total)} & Confirm Order`
                      : 'Confirm Order'}
                  </Button>
                  {loading && <LoadingBox />}
                  <SecurityBadges variant="payment" />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <Footer />
    </div>
  );
}
